"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const ClockLoader_1 = __importDefault(require("react-spinners/ClockLoader"));
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
/** How long a warning stays on screen before it is cleared. */
const WARNING_HIDE_MS = 5000;
const NotificationArea = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    // Keep the notifications received. If it is a progress and it is done, the notification will clear after a timeout
    const [notifications, setNotifications] = react_1.default.useState({});
    /**
     * Drop one notification from the latest state.
     * Reading that state inside the setter avoids restoring a message already dismissed.
     * @param {string} name Notification key
     */
    const removeNotification = (name) => {
        setNotifications((prev) => {
            if (prev[name] === undefined) {
                return prev;
            }
            const next = Object.assign({}, prev);
            delete next[name];
            return next;
        });
    };
    const notificationListener = react_1.default.useCallback((notification) => {
        if (notification.type === 'clearProgress') {
            removeNotification(notification.name);
            return;
        }
        const message = notification.message.map((text) => t(text)).join(': ');
        const uiNotification = notification.type === 'error'
            ? {
                type: 'error',
                color: 'red',
                message
            }
            : notification.type === 'warning'
                ? {
                    type: 'warning',
                    color: 'yellow',
                    message
                }
                : {
                    type: 'progress',
                    color: notification.done ? 'green' : 'grey',
                    message
                };
        // Functional update: a later progress event must not restore a warning already removed from state.
        setNotifications((prev) => (Object.assign(Object.assign({}, prev), { [notification.name]: uiNotification })));
        if (notification.type === 'progress' && notification.done) {
            setTimeout(() => removeNotification(notification.name), 1000);
        }
        if (notification.type === 'warning') {
            setTimeout(() => removeNotification(notification.name), WARNING_HIDE_MS);
        }
    }, []);
    react_1.default.useEffect(() => {
        ServiceLocator_1.default.notificationService.addListener(notificationListener);
        return () => {
            ServiceLocator_1.default.notificationService.removeListener(notificationListener);
        };
    });
    // TODO: Add an 'x' to remove a notification from the area manually.
    return (react_1.default.createElement("div", { className: "tr__top-menu-notifications" }, Object.entries(notifications).map(([name, notification]) => (react_1.default.createElement("div", { key: name, className: "tr__flash-message-container" },
        notification.type === 'progress' && react_1.default.createElement(ClockLoader_1.default, { size: 16, color: "#ffffff" }),
        react_1.default.createElement("p", { className: `_${notification.color}` }, notification.message))))));
};
exports.default = NotificationArea;
//# sourceMappingURL=NotificationArea.js.map